module.exports = "https://static.im-cdn.com/mjc/storefront/Ikkat/static/media/Email.824430b1.svg";